import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Container, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import HomeIcon from "@mui/icons-material/Home";

const NotFound = () => {
  return (
    // Plain Box, not `component="main"`: the layout already renders the page's
    // single <main id="main-content"> landmark. See docs/accessibility.md.
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: "center" }}>
        <Typography
          sx={{
            fontSize: { xs: "5rem", md: "7rem" },
            fontWeight: 900,
            lineHeight: 1,
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.dark.main} 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            mb: 2,
          }}
        >
          404
        </Typography>
        <Typography
          variant="h4"
          sx={{ fontWeight: 800, color: "dark.main", mb: 1.5 }}
        >
          Page not found
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "text.secondary", mb: 4, lineHeight: 1.6 }}
        >
          The page you're looking for doesn't exist or may have been moved.
          Let's get you back on route.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
          <Button
            component={Link}
            to="/home"
            variant="contained"
            size="large"
            startIcon={<HomeIcon />}
            sx={{
              backgroundColor: "primary.main",
              px: 4,
              py: 1.25,
              "&:hover": { backgroundColor: "primary.extraDark" },
            }}
          >
            Back to home
          </Button>
          <Button
            component={Link}
            to="/model-builder"
            variant="outlined"
            size="large"
            endIcon={<ArrowForwardIcon />}
            sx={{
              px: 4,
              py: 1.25,
              borderColor: "primary.main",
              color: "primary.main",
              "&:hover": { borderColor: "primary.extraDark", backgroundColor: "primary.extraLight" },
            }}
          >
            Start Solving
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFound;
